"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-float"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _BeaconTracker = _interopRequireDefault(require("../../utils/beacon/BeaconTracker"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../helpers/DeviceInfoHelper"));

var _DataStore = require("../Stores/DataStore2");

var _GeolocationHelper = _interopRequireDefault(require("../../helpers/GeolocationHelper"));

var _RegisterInstance = _interopRequireDefault(require("../Services/RegisterInstance"));

var GEOLOCATION_TRACKING_ACTIVATED = false;

var ContentEntity = /*#__PURE__*/function () {
  // nothing special so far
  function ContentEntity(json) {
    (0, _classCallCheck2["default"])(this, ContentEntity);

    /**
     * id is unique per system (same entity on dev and prod have DIFFERENT ids)
     */
    this.id = json.id;
    /**
     * uuid is globally unique (same entity on dev and prod have SAME uuid)
     */

    this.uuid = json.uuid;
    this.filename = null;
    this.type = json.type;
    this.md5 = json.md5 ? json.md5.substring(0, 6) : null; // only save md5 start

    this.showPrecondition = json.showPrecondition;
    this.openPrecondition = json.openPrecondition; // not in use for Nuggets

    this.itemid = json.itemid; // currently used for spoc and lecture, maybe later for nuggets

    this.beaconTrackers = [];
  }

  (0, _createClass2["default"])(ContentEntity, [{
    key: "activateTrackings",
    value: function activateTrackings() {
      if (this.openPrecondition) {
        this.activateBeaconTracking(this.openPrecondition, this.id);
        this.activateGeolocationTracking(this.openPrecondition, this.id, 'openPrecondition');
      }

      if (this.showPrecondition) {
        this.activateBeaconTracking(this.showPrecondition, this.id);
        this.activateGeolocationTracking(this.showPrecondition, this.id, 'showPrecondition');
      }
    }
    /**
     * In case there is a show condition and that show condition depends on the (non-)presence of a beacon
     * that beacon needs be monitored
     */

  }, {
    key: "activateBeaconTracking",
    value: function activateBeaconTracking(precondition) {
      if (!precondition || !precondition.active || !precondition.beacons) {
        return;
      }

      if (_BeaconTracker["default"].isBeaconTrackingAvailable() && !_DeviceInfoHelper["default"].isBrowser()) {
        console.log('going to activate beacon tracking according to precondition', precondition.beacons);
        this.beaconTrackers = precondition.beacons.map(function (beaconDefinition) {
          var beaconTracker = new _BeaconTracker["default"](beaconDefinition.name, beaconDefinition.uuid, beaconDefinition.major, beaconDefinition.minor);
          console.log('beaconTracker', beaconTracker);
          beaconTracker.startMonitoring();
          beaconTracker.startRanging();
          return beaconTracker;
        });
      }
    }
  }, {
    key: "addGeoLocationToPlugin",
    value: function () {
      var _addGeoLocationToPlugin = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(check, id) {
        var checkParts, radius, locationParts, lat, lng, action, onEnterOrLeave, options;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                // check: "private.geolocation isInRadius 500m around @52.5087832,13.2299613 [run send_push [on leave]]"
                checkParts = check.split(' ');

                if (!(checkParts.length < 5)) {
                  _context.next = 5;
                  break;
                }

                console.error('check has not enough params');
                return _context.abrupt("return");

              case 5:
                console.log('addGeoLocationToPlugin', id, check);
                radius = checkParts[2];

                if (radius.indexOf('m') !== -1 && radius.indexOf('km') === -1) {
                  radius = (0, _parseInt2["default"])(radius.substring(0, checkParts[2].length - 1));
                } else if (radius.indexOf('km') !== -1) {
                  radius = (0, _parseInt2["default"])(radius.substring(0, checkParts[2].length - 2));
                }

                locationParts = checkParts[4].substring(1, checkParts[4].length).split(',');
                console.log('locationParts', locationParts);
                lat = (0, _parseFloat2["default"])(locationParts[0]);
                lng = (0, _parseFloat2["default"])(locationParts[1]);
                console.log("adding location with id ".concat(id, " with lat ").concat(lat, " and lng ").concat(lng, " and radius ").concat(radius, " to the geofence plugin"));
                action = checkParts.length >= 7 ? checkParts[6] : null;
                onEnterOrLeave = checkParts.length >= 9 ? checkParts[8] : 'both';

                if (['enter', 'leave', 'dwell', 'both'].includes(onEnterOrLeave)) {
                  onEnterOrLeave = 'both';
                }

                options = {
                  id: id,
                  // A unique identifier of geofence
                  lat: lat,
                  // Geo latitude of geofence
                  lng: lng,
                  // Geo longitude of geofence
                  radius: radius,
                  // Radius of geofence in meters
                  transitionType: onEnterOrLeave // 'enter', 'leave', or 'both'

                };

                if (action) {
                  options.action = action; // 'push_test_with_store' or 'ably_test_with_store'
                }

                console.log('going to register geofence', options);

                if (!window.GeofencePlugin) {
                  _context.next = 22;
                  break;
                }

                _context.next = 22;
                return window.GeofencePlugin.addOrUpdate(options);

              case 22:
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](0);
                console.error('error in addGeoLocationToPlugin', _context.t0);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 24]]);
      }));

      function addGeoLocationToPlugin(_x, _x2) {
        return _addGeoLocationToPlugin.apply(this, arguments);
      }

      return addGeoLocationToPlugin;
    }()
  }, {
    key: "activateGeolocationTracking",
    value: function () {
      var _activateGeolocationTracking = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(precondition, id, subId) {
        var _this = this;

        var checks, conditions, geoChecks;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!precondition || !precondition.active)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                // console.log('activateGeolocationTracking for id', id, subId)
                checks = precondition.checks;
                conditions = precondition.conditions;
                geoChecks = [];

                if (!(!conditions && !checks)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                if (checks) {
                  checks.forEach(function (check) {
                    if (check.indexOf(_DataStore.DATA_STORE_PATHS.GEOLOCATION) >= 0) {
                      console.log('pushing check to geochecks', check);
                      geoChecks.push(check);
                    }
                  });
                }

                if (conditions) {
                  conditions.forEach(function (condition) {
                    condition.forEach(function (check) {
                      if (check.indexOf(_DataStore.DATA_STORE_PATHS.GEOLOCATION) >= 0) {
                        console.log('pushing check to geochecks', check);
                        geoChecks.push(check);
                      }
                    });
                  });
                }

                if (!(GEOLOCATION_TRACKING_ACTIVATED || !precondition || !precondition.active || geoChecks.length === 0)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return");

              case 11:
                if (!(geoChecks.length > 0)) {
                  _context2.next = 19;
                  break;
                }

                if (!window.GeofencePlugin) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return window.GeofencePlugin.requestPermission();

              case 15:
                geoChecks.forEach(function (check, index) {
                  _this.addGeoLocationToPlugin(check, "".concat(id, "-").concat(subId, "-").concat(index));
                }); // no need to wait

                _RegisterInstance["default"].getApplicationInstanceId().then(function (appInstanceId) {
                  console.log('setting geofence app instance id to', appInstanceId);
                  window.GeofencePlugin.setAppInstanceId(appInstanceId);
                });

              case 17:
                _context2.next = 19;
                return _GeolocationHelper["default"].watchGeolocation();

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function activateGeolocationTracking(_x3, _x4, _x5) {
        return _activateGeolocationTracking.apply(this, arguments);
      }

      return activateGeolocationTracking;
    }()
  }]);
  return ContentEntity;
}();

var _default = ContentEntity;
exports["default"] = _default;